import React from "react";

import Page from "pages/Page";

const Maintenance = ({ componentName = "[Maintenance]" }) => {
    return (
        <Page
            componentName={componentName}
            internal={false}
        >
            <div className="gallery">
                <h3>KarunaCLOUD is currently under maintenance. Please try again later or contact a Karuna Admin.</h3>
                <br/>
                {" "}
                <br/>
            </div>
        </Page>
    );
};

export default Maintenance;

